import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"392px"} }
const _hoisted_2 = { class: "overlay-wrapper card-rounded min-h-225px overflow-hidden h-275px border border-1" }
const _hoisted_3 = {
  key: 0,
  class: "w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", {
  class: "text-black-50 opacity-20 fs-1",
  style: {"transform":"rotate(45deg)"}
}, " User has not uploaded this file yet ", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark card-rounded bg-opacity-25" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
], -1)
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = {
  key: 0,
  class: "m-0 px-1"
}
const _hoisted_11 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_12 = {
  href: "#",
  class: "fs-4 text-dark fw-bold text-hover-primary text-dark lh-base"
}
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  key: 0,
  class: "text-primary me-4 fw-bold fs-3"
}
const _hoisted_15 = {
  key: 1,
  class: "text-danger me-4 fw-bold fs-3"
}
const _hoisted_16 = { class: "fw-semibold fs-5 text-gray-600 text-dark mt-3 mb-5 d-flex" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", { class: "text-danger me-4" }, "Reason:", -1)
const _hoisted_18 = { class: "" }

import VuePdfEmbed from "vue-pdf-embed";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { inject, onMounted, Ref, ref, watch } from "vue";
import { FileFormatTypes } from "@/core/types/FileFormatTypes";
import { getImageUrl } from "@/core/plugins/ProcessImageLink";
import { Check, Close, Delete, Download } from "@element-plus/icons-vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserImageDoc',
  props: {
    title: {},
    descp: {},
    media: {},
    mediaType: {},
    enableDelete: { type: Boolean },
    verificationDetails: {},
    context: {},
    disabledAction: { type: Boolean }
  },
  emits: ["fileDeleted"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const contentTypeStr = ref(props.media?.contentType);
const contentType = ref(FileFormatTypes.JPEG);
const isLoading = ref(false);
const contentUrlWithToken = ref("");
const getContentUrlWithToken = async () => {
  if (!props.media) return;
  isLoading.value = true;
  contentUrlWithToken.value = await TenantGlobalService.getImageUrlWithToken(
    getImageUrl(props.media?.guid)
  );
  isLoading.value = false;
};

const isDownloading = ref(false);
const downloadByGuid = async (guid: string, fileName: string) => {
  try {
    isDownloading.value = true;
    const res = await TenantGlobalService.downloadFileByGuid(guid, fileName);
    isDownloading.value = false;
  } catch (e) {
    console.log(e);
    isDownloading.value = false;
  }
};

watch(() => props.media, getContentUrlWithToken);

const openConfirmModal = inject(InjectKeys.OPEN_CONFIRM_MODAL);

const openRejectModal = inject(
  InjectKeys.OPEN_REJECT_REASON_MODAL,
  (formData: any) => MsgPrompt.error("Get Modal Failed")
);

const handleRejectDocument = () => {
  openRejectModal((formData: any) =>
    UserService.rejectUserDocument(
      props.verificationDetails.id,
      props.media.id,
      formData
    )
      .then(() => MsgPrompt.success("Document Rejected Successfully"))
      .then(() => emits("fileDeleted"))
  );
};

const fileShowRef = inject<Ref>(InjectKeys.FILE_SHOW_REF);

const handleMouseEnter = async (media) => {
  if (!media) return;
  isLoading.value = true;
  await fileShowRef?.value?.show(media);
  isLoading.value = false;
};

const handleApproveDocument = () => {
  openConfirmModal?.(
    () =>
      UserService.approveUserDocument(
        props.verificationDetails.id,
        props.media.id
      )
        .then(() => MsgPrompt.success("Document Approved Successfully"))
        .then(() => emits("fileDeleted")),
    undefined,
    {
      confirmText: "Confirm to approve this document?",
      confirmColor: "success",
    }
  );
};

const deleteFile = () => {
  openConfirmModal?.(
    () =>
      UserService.deleteVerificationDocForUser(
        props.verificationDetails.id,
        props.media.id
      ).then(() => emits("fileDeleted")),
    undefined,
    {
      confirmText: "Confirm to delete this document?",
      confirmColor: "warning",
    }
  );
};

onMounted(async () => {
  contentType.value =
    {
      ["application/pdf"]: FileFormatTypes.PDF,
      ["image/jpeg"]: FileFormatTypes.JPEG,
      ["image/jpg"]: FileFormatTypes.JPG,
      ["image/png"]: FileFormatTypes.PNG,
      ["text/plain"]: FileFormatTypes.TXT,
    }[contentTypeStr.value] ?? FileFormatTypes.JPEG;

  await getContentUrlWithToken();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleMouseEnter(props.media))),
      class: "d-block overlay mb-4",
      "data-fslightbox": "lightbox-hot-sales",
      href: "#"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(ScaleLoader, { color: '#ffc730' })
            ]))
          : (props.media)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (
              [
                _unref(FileFormatTypes).JPEG,
                _unref(FileFormatTypes).JPG,
                _unref(FileFormatTypes).PNG,
              ].includes(contentType.value as any)
            )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "w-100 overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded h-275px",
                      style: _normalizeStyle(
              contentUrlWithToken.value !== ''
                ? `background-image: url(${contentUrlWithToken.value});`
                : ''
            )
                    }, null, 4))
                  : (
              [_unref(FileFormatTypes).PDF].includes(contentType.value as any) &&
              contentUrlWithToken.value !== ''
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_unref(VuePdfEmbed), {
                          source: contentUrlWithToken.value,
                          class: ""
                        }, null, 8, ["source"])
                      ]))
                    : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadByGuid(_ctx.media?.guid, _ctx.media?.fileName))),
        type: "primary",
        icon: _unref(Download) as any,
        circle: "",
        loading: isDownloading.value
      }, null, 8, ["icon", "loading"]),
      (!props.disabledAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.title), 1),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.media?.status === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Approved "))
                  : _createCommentVNode("", true),
                (_ctx.media?.status === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Rejected "))
                  : _createCommentVNode("", true),
                (_ctx.media?.status === 0)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      onClick: handleApproveDocument,
                      type: "success",
                      icon: _unref(Check) as any,
                      circle: ""
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                (_ctx.media?.status === 0)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      onClick: handleRejectDocument,
                      type: "danger",
                      icon: _unref(Close) as any,
                      circle: ""
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                (props.enableDelete ?? false)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 4,
                      onClick: deleteFile,
                      type: "warning",
                      icon: _unref(Delete) as any,
                      circle: ""
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.media?.status === 3)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_17,
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.media.rejectedReason), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})